import { render, staticRenderFns } from "./Historial.vue?vue&type=template&id=664b1066&scoped=true&"
import script from "./Historial.vue?vue&type=script&lang=ts&"
export * from "./Historial.vue?vue&type=script&lang=ts&"
import style0 from "./Historial.vue?vue&type=style&index=0&id=664b1066&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664b1066",
  null
  
)

export default component.exports